const Search = () => {
  const searchField = document.querySelector(".search");
  const activeClass = "form-field__input--touched";
  const searchOpener = document.querySelector(".search-opener");
  const pageContainer = document.querySelector(".page");

  if (searchField) {
    const searchFieldInput = searchField.querySelector(".form-field__input");
    const button = searchField.querySelector(".search-action");
    const dropdown = document.querySelector(".search__dropdown");
    const dropdownItems = Array.from(
      dropdown.querySelectorAll(".search__dropdown-item")
    );
    const backdrop = document.querySelector(".page__backdrop");

    //Отображение, скрытие самого поиска
    if (searchOpener && pageContainer && backdrop) {
      searchOpener.addEventListener("click", () => {
        if (pageContainer.classList.contains("show-search")) {
          pageContainer.classList.remove("show-search");
        } else {
          pageContainer.classList.add("show-search");

          if (pageContainer.classList.contains("show-menu")) {
            pageContainer.classList.remove("show-menu");
          }

          setTimeout(() => {
            searchFieldInput.focus();
          }, 50);
        }
      });

      backdrop.addEventListener("click", () => {
        pageContainer.classList.remove("show-search");
      });

      document.addEventListener("keydown", (e) => {
        if (e.code == "Escape") {
          pageContainer.classList.remove("show-search");
        }
      });
    }

    if (dropdown && button && dropdownItems.length > 0) {
      button.classList.add("show-results");
      button.classList.remove("clear-input");
      dropdown.classList.add("active");
    } else {
      button.classList.remove("show-results");
      button.classList.add("clear-input");
      dropdown.classList.remove("active");
    }

    //Логика для пояления крестика при вводе, без результатов, а так же обработка клика по крестику
    const clearButton = button.classList.contains("clear-input");

    const handleInputChange = (e) => {
      if (e.target.value && !searchFieldInput.classList.contains(activeClass)) {
        searchFieldInput.classList.add(activeClass);
      } else if (
        !e.target.value &&
        searchFieldInput.classList.contains(activeClass)
      ) {
        searchFieldInput.classList.remove(activeClass);
      }
    };

    const handleButtonClick = (e) => {
      searchFieldInput.focus();
      searchFieldInput.classList.remove(activeClass);
    };

    if (searchFieldInput && clearButton) {
      button.addEventListener("click", handleButtonClick);
      searchFieldInput.addEventListener("input", handleInputChange);
    }

    //Свайп в сторону для скрытия меню на мобильных телефонах
    let xDown = null;
    let yDown = null;

    function handleTouchStart(evt) {
      xDown = evt.touches[0].clientX;
      yDown = evt.touches[0].clientY;
    }

    function handleTouchMove(evt) {
      if (!xDown || !yDown) {
        return;
      }

      const xUp = evt.touches[0].clientX;
      const yUp = evt.touches[0].clientY;

      const xDiff = xDown - xUp;
      const yDiff = yDown - yUp;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        if (xDiff < 0) {
          // Свайп в право
          pageContainer.classList.remove("show-search");
        } else {
          // Свайп в лево
        }
      } 
      
      xDown = null;
      yDown = null;
    }

    document.addEventListener('touchstart', handleTouchStart, false);  
    document.addEventListener('touchmove', handleTouchMove, false);
  }
};

export default Search;
